import { getLeases } from '~modules/leases/api/api-service/leases';

import { useEntityList } from '~hooks/api/use-entity-list';

import { ApiHookProps } from '~app/types/api/api-hook';

import { ApiLease } from '~shared/types';

type Props = ApiHookProps<ApiLease>;

export const useGetLeases = ({ params, searchBy, options }: Props = {}) => {
  return useEntityList<ApiLease>('leases', {
    queryFn: getLeases,
    params,
    searchBy,
    // options
    queryOptions: options,
  });
};
